module.exports = __webpack_public_path__ + "1fefe92af8852355236fe2d6648f4d2b.svg";